import React from 'react';
import { useTranslation } from 'react-i18next';
import { ASSOCIATED_KEYS_PATH } from '../../../router/paths';
import { useCustomHistory } from '../../../router/navigation';
import { buildRouterPath } from '../../../router/utils';
import { AccountMenuItem } from '@make-software/csprclick-ui';

export const AssociatedKeysMenuItem = () => {
  const { t } = useTranslation();
  const history = useCustomHistory();

  const navigateToAssociatedKeysPage = () => {
    history.push(buildRouterPath(ASSOCIATED_KEYS_PATH, undefined, undefined));
  };

  return (
    <AccountMenuItem
      label={t('Associated Keys')}
      onClick={navigateToAssociatedKeysPage}
      icon={'assets/icons/ic-key.svg'}
    />
  );
};
